import { cn } from '../lib/cn';

/**
 * FSSAI-style veg / non-veg indicator: a bordered square with a filled
 * dot (veg = green) or triangle (non-veg = red). `bare` renders just the
 * glyph inline (as used in menu titles).
 */
export function VegMark({
  veg,
  bare = false,
  className
}: {
  /** Undefined = unknown. Renders nothing rather than guessing — a wrong veg mark is a
   *  dietary and religious problem, not a cosmetic one. */
  veg?: boolean;
  bare?: boolean;
  className?: string;
}) {
  if (veg === undefined) return null;
  const color = veg ? 'text-veg' : 'text-nonveg';
  const border = veg ? 'border-veg' : 'border-nonveg';

  if (bare) {
    return (
      <span className={cn('text-[10px] leading-none', color, className)} aria-label={veg ? 'Veg' : 'Non-veg'}>
        {veg ? '●' : '▲'}
      </span>
    );
  }

  return (
    <span
      className={cn(
        'inline-flex h-3.5 w-3.5 items-center justify-center rounded-[3px] border-[1.5px] text-[8px] leading-none',
        border,
        color,
        className
      )}
      aria-label={veg ? 'Veg' : 'Non-veg'}
    >
      {veg ? '●' : '▲'}
    </span>
  );
}
